export default __webpack_public_path__ + "static/media/blue-error.2c57fc84.svg";